<template>
  <b-container class="h-100">
    <b-row class="h-100">
      <b-col
        class="d-flex flex-column justify-content-center login-wrapper--right-form"
      >
        <div class="d-flex">
          <b-img src="/img/logo.svg" fluid />
        </div>

        <div class="mt-4">
          <h3 class="font-weight-bold">Your Details</h3>
          <p class="mt-3 grey--text">
            We need a little more details to complete your account set up.
            Please complete the form below.
          </p>
        </div>

        <transition name="slide-fade">
          <b-form
            @submit.prevent="onSubmitInfo"
            enctype="multipart/form-data"
            class="mt-4"
          >
            <b-row no-gutters>
              <b-col cols="12">
                <b-form-group id="input-group-4" class="mb-0">
                  <label class="font-weight-bold">Full Name</label>
                  <b-form-input
                    id="input-4"
                    v-model="formInfo.full_name"
                    class="form-control effect-26"
                    :class="formInfo.full_name ? 'has-content' : ''"
                    type="text"
                    autofocus
                    required
                    placeholder="Enter full name"
                  ></b-form-input>
                  <div
                    class="input-error"
                    v-if="formInfo.$getError('full_name')"
                  >
                    {{ formInfo.$getError('full_name')[0] }}
                  </div>
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <label class="font-weight-bold">USI Number</label>
                <b-input-group id="input-group-usi" class="mb-2">
                  <b-form-input
                    id="input-usi"
                    v-model="formInfo.usi"
                    type="text"
                    placeholder="Enter USI Number"
                    aria-describedby="input-usi-feedback"
                  >
                  </b-form-input>
                  <template #append>
                    <b-input-group-text id="popover-button-sync" class="usi">
                      <b-icon
                        icon="info-circle"
                        variant="dark"
                        @click="showFindUsi = !showFindUsi"
                      />
                    </b-input-group-text>
                    <b-popover
                      :show.sync="showFindUsi"
                      target="popover-button-sync"
                      placement="top"
                    >
                      Find your USI Number
                      <strong
                        ><b-link
                          href="https://www.usi.gov.au/students/find-your-usi"
                          target="_blank"
                          >here</b-link
                        ></strong
                      >
                    </b-popover>
                  </template>
                </b-input-group>
                <div class="input-error" v-if="formInfo.$getError('usi')">
                  {{ formInfo.$getError('usi')[0] }}
                </div>
              </b-col>

              <b-col cols="12">
                <b-form-group id="input-group-6" class="mb-0">
                  <label class="font-weight-bold">Mobile Number</label>
                  <b-input-group class="mb-0">
                    <b-input-group-append>
                      <v-select
                        :options="countriesList"
                        :value="countryCode"
                        @input="setSelected"
                        label="value"
                        class="country-code-list"
                      >
                        <template slot="option" slot-scope="option">
                          <img :src="option.flag" class="radius-0" />
                          {{ option.text }}
                        </template>
                      </v-select>
                    </b-input-group-append>

                    <b-form-input
                      id="input-6"
                      v-model="formInfo.phone_number"
                      class="form-control effect-26"
                      :class="formInfo.phone_number ? 'has-content' : ''"
                      type="text"
                      placeholder="Enter phone number"
                      required
                    />
                  </b-input-group>

                  <div
                    class="input-error"
                    v-if="formInfo.$getError('phone_number')"
                  >
                    {{ formInfo.$getError('phone_number')[0] }}
                  </div>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <div class="datepicker-container">
                  <label class="font-weight-bold">Date of Birth</label>
                  <b-form-input
                    id="input-date"
                    type="text"
                    required
                    placeholder="DD/MM/YYYY"
                    aria-describedby="input-date-feedback"
                    maxlength="10"
                    v-model="formInfo.birthdate"
                    :formatter="formatDate"
                  />
                </div>

                <div class="invalid-feedback d-block">
                  {{ errors.birthdate }}
                </div>
              </b-col>
              <b-col cols="12" class="mb-5">
                <b-form-group id="input-group-7" class="mb-4">
                  <label class="font-weight-bold">Company</label>
                  <b-form-input
                    id="input-7"
                    v-model="formInfo.company"
                    class="form-control effect-26"
                    :class="formInfo.company ? 'has-content' : ''"
                    type="text"
                    autofocus
                    required
                    placeholder="Enter full name"
                  ></b-form-input>
                  <div class="input-error" v-if="formInfo.$getError('company')">
                    {{ formInfo.$getError('company')[0] }}
                  </div>
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="6" class="pr-lg-2">
                <b-button
                  @click="backToRegister"
                  class="btn-outlined bg-white text-dark"
                  block
                  >Back</b-button
                >
              </b-col>

              <b-col cols="12" lg="6" class="pl-lg-2" block>
                <b-button class="pr-2" type="submit" variant="primary" block>
                  <b-spinner small v-if="formInfo.$busy" />
                  <span>Complete</span>
                  <b-img
                    class="float-right"
                    src="/img/arrow-right.svg"
                    alt="arrow-right"
                    width="20"
                  />
                </b-button>
              </b-col>
            </b-row>
            <image-cropper
              v-model="show"
              @change="uploadPhoto"
              @success="successUpload"
              @close="closeUpload"
            />
          </b-form>
        </transition>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import 'vue-select/dist/vue-select.css'
import { mapState, mapActions } from 'vuex'
import Form from '@/utils/form'
import vSelect from 'vue-select'
import DatePicker from 'vuejs-datepicker'
import ImageCropper from '@/components/modals/ImageCropper'

export default {
  name: 'OnboardingPage',

  components: {
    vSelect,
    DatePicker,
    ImageCropper
  },

  data() {
    return {
      countryCode: '+61',
      gender: [
        { value: null, text: 'Select Gender' },
        { value: 'male', text: 'Male' },
        { value: 'female', text: 'Female' }
      ],
      formInfo: new Form({
        full_name: '',
        usi: '',
        phone_number: '',
        birthdate: null,
        company: '',
        avatar: null
      }),
      show: false,
      format: 'dd/MM/yy',
      disabledDates: {
        from: this.getDateToday()
      },
      highlighted: {
        dates: [this.getDateToday()]
      },
      errors: {
        birthdate: null
      },
      showFindUsi: false
    }
  },

  computed: {
    ...mapState({
      user: state => state.auth.user,
      countries: state => state.country.countries
    }),

    countriesList() {
      let countries = this.countries.map(country => {
        let code = country.dial_code

        if (code.replace(' ', '') !== '') {
          code = `+` + code.replace('+', '')

          return {
            value: code,
            text: `${country.flag} (${code})`,
            flag: `/img/flags/${country.iso2}.png`
          }
        }
      })

      return countries.filter(country => {
        return !!country
      })
    }
  },

  methods: {
    ...mapActions({
      getCountries: 'country/getCountries',
      changeAvatar: 'auth/changeAvatar'
    }),

    setSelected(country) {
      this.countryCode = country.value
    },

    async onSubmitInfo(evt) {
      this.formInfo.$busy = true

      await this.$api
        .put(`users/${this.user.id}`, {
          full_name: this.formInfo.full_name,
          usi: this.formInfo.usi,
          phone_number: `${this.countryCode}${this.formInfo.phone_number}`,
          company: this.formInfo.company,
          birthdate: this.convertToISO(this.formInfo.birthdate)
        })
        .then(({ data }) => {
          this.formInfo.$busy = false
          this.$store.commit('auth/setUser', data.data)
          this.show = true
          this.formInfo.$clearErrors()
        })
        .catch(error => {
          this.formInfo.$handleError(error)
        })
    },

    async uploadPhoto(image) {
      let data = new FormData()
      data.append('avatar', image)
      await this.changeAvatar(data)

      this.$root.$emit('uploadComplete')
    },

    successUpload() {
      this.show = false
      this.$router.replace({
        name: 'home.welcome-page',
        params: { show: true }
      })
    },

    closeUpload() {
      this.show = false
    },

    backToRegister() {
      this.$store.commit('auth/clearToken')
      this.$store.commit('auth/clearUser')
      this.$router.replace({ name: 'auth.register-page' })
    }
  },

  created() {
    this.getCountries()
  },

  watch: {
    'form.full_name'() {
      this.form.$clearError('full_name')
    },
    'form.phone_number'() {
      this.form.$clearError('phone_number')
    }
  }
}
</script>

<style scoped lang="scss">
.radius-0 {
  border-radius: 0;
  border: 1px solid #333333;
}
.custom-label {
  position: absolute;
  color: #78849e;
  margin-top: -14px;
  font-size: 12px;
}

.custom-input {
  position: absolute;
  border: none;
  margin-top: -32px;
  height: 0px;
  width: 56px;
  margin-left: 3px;
  background: white;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.display-equal-left {
  width: 20%;
}

.display-equal-right {
  width: 75%;
}

.input-group-append {
  margin-left: -1px;
  margin-right: -2px;
}

.input-group > .form-control:not(:last-child),
.input-group > .country-code-list:not(:last-child) {
  all: none !important;
}

.country-code-list {
  outline: none !important;
  border: 2px solid #e5e5e5;
  border-radius: 8px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  margin-right: -1px;
  z-index: 1;

  &:focus {
    -webkit-box-shadow: none;
    box-shadow: none;
    border: 2px solid #2c66d5;
  }
}

.usi {
  cursor: pointer;
  background: white;
  border: 2px solid #e5e5e5;
}
</style>
